import React, { useEffect, useState } from "react";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ProductDetails from "./ProductDetails";
import Barcode from "react-barcode";
import { QRCodeCanvas } from "qrcode.react";
import { addDays } from "date-fns";
import moment from "moment";

import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";

const ProductSale = (props) => {
  const [loading, setLoading] = useState(false);

  const [tableState, setTableState] = useState({
    loading: true,
  });

  const [products, setProduct] = useState([]);

  const [saleSortOrder, setSaleSortOrder] = useState(null);

  const [expandedRows, setExpandedRows] = useState({});

  const [totalCustomersSale, setTotalCustomersSale] = useState({});

  const [customerSaleLoading, setCustomerSaleLoading] = useState({});

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");

  const [globalSearch, setGlobalSearch] = useState("");
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState(null);

  const [modalDashboardDataRange, setModalDashboardDataRange] =
    useState(false);

  const [dashboardShowDate, setDashboardShowDate] = useState(() => ({
    startDate: addDays(new Date(), -7),
    endDate: new Date(),
    key: "selection",
  }));

  const [dateRangeState, setDateRangeState] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const toggleDashboardDataRange = () => {
    setModalDashboardDataRange((prev) => !prev);
  };



  const fetchCategories = () => {
    postMethod(`api/masters/product/category/getcategories`, {})
      .then((res) => {
        console.log("Category Response:", res);

        if (res && res.data) {
          setCategories(res.data);
        } else {
          setCategories([]);
        }
      })
      .catch((error) => {
        console.error("Category API Error:", error);
        setCategories([]);
      });
  };


  const fetchSubCategories = (categoryId) => {
    if (!categoryId) {
      setSubCategories([]);
      return;
    }

    postMethod(`api/masters/product/subcategory/getSubcategoryForm`, {
      category_id: categoryId,
    })
      .then((res) => {
        console.log("Sub Category Response:", res);

        if (res && res.data) {
          setSubCategories(res.data);
        } else {
          setSubCategories([]);
        }
      })
      .catch((error) => {
        console.error("Sub Category API Error:", error);
        setSubCategories([]);
      });
  };



  const fetchData = () => {
    setTableState({
      loading: true,
    });

    const payload = {
      from_date: moment(dashboardShowDate.startDate).format("YYYY-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("YYYY-MM-DD"),
    };

    console.log("Product Sale Payload:", payload);

    postMethod(`api/masters/retailer/product_sale_report_details`, payload)
      .then((res) => {
        console.log("Product Sale Response:", res);

        if (res && res.data) {
          setProduct(res.data);
        } else {
          setProduct([]);
        }
      })
      .catch((error) => {
        console.error("Product Sale API Error:", error);
        setProduct([]);
      })
      .finally(() => {
        setTableState({
          loading: false,
        });
      });
  };



  const filteredProducts = products.filter((record) => {
    const recordCategory = String(record.category_name || "")
      .trim()
      .toLowerCase();

    const recordSubCategory = String(record.subcategory_name || "")
      .trim()
      .toLowerCase();

    const selectedCategoryValue = String(selectedCategory || "")
      .trim()
      .toLowerCase();

    const selectedSubCategoryValue = String(selectedSubCategory || "")
      .trim()
      .toLowerCase();

    const categoryMatch =
      !selectedCategoryValue ||
      recordCategory === selectedCategoryValue;


    const subCategoryMatch =
      !selectedSubCategoryValue ||
      recordSubCategory === selectedSubCategoryValue;

    const searchValue = String(globalSearch || "")
      .trim()
      .toLowerCase();

    const globalSearchMatch =
      !searchValue ||
      [
        record.product_code,
        record.product_name,
        record.category_name,
        record.subcategory_name,
        record.size_length,
        record.color,
        record.price,
        record.balance_qty,
        record.sales_qty,
      ]
        .map((value) => String(value ?? "").toLowerCase())
        .some((value) => value.includes(searchValue));

    return (
      categoryMatch &&
      subCategoryMatch &&
      globalSearchMatch
    );
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (!saleSortOrder) {
      return 0;
    }

    const saleA = Number(a.sales_qty || 0);
    const saleB = Number(b.sales_qty || 0);

    if (saleSortOrder === "desc") {
      return saleB - saleA;
    }

    if (saleSortOrder === "asc") {
      return saleA - saleB;
    }

    return 0;
  });

  const handleProductCodeSort = () => {
    setSaleSortOrder((prevOrder) => {
      if (!prevOrder) {
        return "desc";
      }

      if (prevOrder === "desc") {
        return "asc";
      }

      return "desc";
    });
  };

  const handleCategoryChange = (e) => {
    const categoryName = e.target.value;

    setSelectedCategory(categoryName);

    setSelectedSubCategory("");

    setExpandedRows({});
    setTotalCustomersSale({});

    const selectedCategoryData = categories.find((item) => {
      const name = item.category_name || item.name || "";

      return (
        String(name).trim().toLowerCase() ===
        String(categoryName).trim().toLowerCase()
      );
    });

    if (categoryName && selectedCategoryData) {
      const id =
        selectedCategoryData.category_id ||
        selectedCategoryData.id;

      fetchSubCategories(id);
    } else {
      setSubCategories([]);
    }
  };

  const handleSubCategoryChange = (e) => {
    const subCategoryName = e.target.value;

    setSelectedSubCategory(subCategoryName);

    setExpandedRows({});
    setTotalCustomersSale({});
  };


  const handleClearFilters = () => {
    setSelectedCategory("");
    setSelectedSubCategory("");
    setGlobalSearch("");

    setSubCategories([]);

    setExpandedRows({});
    setTotalCustomersSale({});
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearch(e.target.value);


    setExpandedRows({});
    setTotalCustomersSale({});
  };

  useEffect(() => {
    fetchCategories();
    fetchData();

    const handleOutsideClick = () => setActiveDropdownId(null);
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, []);



  const browse_customers_sale = async (productId) => {
    try {
      setCustomerSaleLoading((prev) => ({
        ...prev,
        [productId]: true,
      }));

      const data = await postMethod(
        "api/masters/retailer/product_sale_report_by_customer",
        {
          product_id: productId,

          from_date: moment(
            dashboardShowDate.startDate
          ).format("YYYY/MM/DD"),

          to_date: moment(
            dashboardShowDate.endDate
          ).format("YYYY/MM/DD"),
        }
      );

      console.log("Customer Sale API Response:", data);

      setTotalCustomersSale((prev) => ({
        ...prev,
        [productId]: data?.data || [],
      }));
    } catch (error) {
      console.error("Customer Sale API Error:", error);

      setTotalCustomersSale((prev) => ({
        ...prev,
        [productId]: [],
      }));
    } finally {
      setCustomerSaleLoading((prev) => ({
        ...prev,
        [productId]: false,
      }));
    }
  };


  const toggleCustomerSale = async (productId) => {
    if (expandedRows[productId]) {
      setExpandedRows((prev) => ({
        ...prev,
        [productId]: false,
      }));

      return;
    }

    setExpandedRows((prev) => ({
      ...prev,
      [productId]: true,
    }));

    await browse_customers_sale(productId);
  };

  const formatDateTime = (date) => {
    if (!date) {
      return "-";
    }

    try {
      const value = String(date).trim();

      if (value.includes(" ")) {
        const [datePart, timePart] = value.split(" ");

        const [year, month, day] = datePart.split("-");
        const [hour, minute] = timePart.split(":");

        if (year && month && day && hour && minute) {
          return `${day}/${month}/${year} ${hour}:${minute}`;
        }
      }

      if (value.includes("T")) {
        const datePart = value.substring(0, 10);
        const timePart = value.substring(11, 16);

        const [year, month, day] = datePart.split("-");

        return `${day}/${month}/${year} ${timePart}`;
      }

      return "-";
    } catch (error) {
      console.error("Date formatting error:", error, date);
      return "-";
    }
  };

  const loadImageAsBase64 = async (src) => {
    if (!src) return null;
    const cleanSrc = src.trim();
    if (cleanSrc.startsWith("data:")) return cleanSrc;

    // 1. Try Direct Fetch
    try {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3000);
      const res = await fetch(cleanSrc, { signal: controller.signal });
      clearTimeout(timer);
      if (res.ok) {
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) { }

    // 2. Try Image element with canvas
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || img.width || 60;
          canvas.height = img.naturalHeight || img.height || 60;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL("image/jpeg", 0.85));
        } catch (e) {
          resolve(cleanSrc);
        }
      };
      img.onerror = () => resolve(null);
      img.src = cleanSrc;
    });
  };

  // Download Product Sales in Excel
  const downloadExcel = () => {
    try {
      setDownloadingExcel(true);
      if (!sortedProducts || sortedProducts.length === 0) {
        alert("No products available to download");
        setDownloadingExcel(false);
        return;
      }

      const headers = [
        "S.No",
        "Product Code",
        "Product Name",
        "Category",
        "Sub Category",
        "Price",
        "Size",
        "Color",
        "Image",
        "Balance Qty",
        "Total Sale",
      ];

      const sheetData = [
        headers,
        ...sortedProducts.map((item, index) => {
          const imgSrc = item.image_path
            ? item.isImageUrl === true || item.isImageUrl === "true"
              ? item.image_path
              : (item.url_image || "") + item.image_path
            : "No Image";

          return [
            index + 1,
            item.product_code || "",
            item.product_name || "",
            item.category_name || "",
            item.subcategory_name || "",
            item.price != null ? Number(item.price).toFixed(2) : "-",
            item.size_length || "-",
            item.color || "-",
            imgSrc,
            item.balance_qty != null ? item.balance_qty : 0,
            item.sales_qty != null ? item.sales_qty : 0,
          ];
        }),
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      worksheet["!cols"] = [
        { wch: 6 },
        { wch: 18 },
        { wch: 28 },
        { wch: 18 },
        { wch: 18 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 35 },
        { wch: 14 },
        { wch: 14 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Product Sales");
      const dateStr = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
      XLSX.writeFile(workbook, `Product_Sales_${dateStr}.xlsx`);
    } catch (err) {
      console.error("Excel download error:", err);
      alert("Failed to download Excel");
    } finally {
      setDownloadingExcel(false);
    }
  };

  // Download Product Sales in PDF
  const downloadPDF = async () => {
    try {
      setDownloadingPdf(true);
      if (!sortedProducts || sortedProducts.length === 0) {
        alert("No products available to download");
        setDownloadingPdf(false);
        return;
      }

      // Preload all images to Base64
      const loadedImages = await Promise.all(
        sortedProducts.map((p) => {
          const imgSrc = p.image_path
            ? p.isImageUrl === true || p.isImageUrl === "true"
              ? p.image_path
              : (p.url_image || "") + p.image_path
            : null;
          return loadImageAsBase64(imgSrc);
        })
      );

      const dateStr = `${moment(dashboardShowDate.startDate).format("DD/MM/YYYY")} - ${moment(dashboardShowDate.endDate).format("DD/MM/YYYY")}`;
      const tempDiv = document.createElement("div");
      tempDiv.id = "productsale-pdf-export-container";
      tempDiv.style.padding = "0px";
      tempDiv.style.margin = "0px";
      tempDiv.style.boxSizing = "border-box";
      tempDiv.style.fontFamily = "Arial, sans-serif";
      tempDiv.style.background = "#ffffff";
      tempDiv.style.color = "#333333";
      tempDiv.style.width = "100%";

      const totalSaleQty = sortedProducts.reduce(
        (total, record) => total + Number(record.sales_qty || 0),
        0
      );

      const rowsHtml = sortedProducts
        .map((p, idx) => {
          const base64Img = loadedImages[idx];
          const balQty = p.balance_qty != null ? p.balance_qty : 0;
          const saleQty = p.sales_qty != null ? p.sales_qty : 0;

          return `
            <tr style="page-break-inside: avoid; border-bottom: 1px solid #e0e0e0; ${idx % 2 === 1 ? "background-color: #f9fafb;" : ""}">
              <td style="padding: 5px 6px; text-align: center; font-size: 10px; vertical-align: middle;">${idx + 1}</td>
              <td style="padding: 5px 6px; font-weight: bold; font-size: 10px; vertical-align: middle;">${p.product_code || "-"}</td>
              <td style="padding: 5px 6px; font-size: 10px; vertical-align: middle;">${p.product_name || "-"}</td>
              <td style="padding: 5px 6px; font-size: 10px; vertical-align: middle;">${p.category_name || "-"}</td>
              <td style="padding: 5px 6px; font-size: 10px; vertical-align: middle;">${p.subcategory_name || "-"}</td>
              <td style="padding: 5px 6px; font-size: 10px; text-align: right; vertical-align: middle;">${p.price != null ? "₹" + Number(p.price).toFixed(2) : "-"}</td>
              <td style="padding: 5px 6px; font-size: 10px; text-align: center; vertical-align: middle;">${p.size_length || "-"}</td>
              <td style="padding: 5px 6px; font-size: 10px; text-align: center; vertical-align: middle;">${p.color || "-"}</td>
              <td style="padding: 5px 6px; text-align: center; vertical-align: middle;">
                ${base64Img
              ? `<img src="${base64Img}" width="34" height="34" style="width: 34px; height: 34px; object-fit: cover; border-radius: 3px; display: inline-block; vertical-align: middle;" />`
              : `<span style="font-size: 9px; color: #888;">No Image</span>`
            }
              </td>
              <td style="padding: 5px 6px; font-size: 10px; text-align: center; font-weight: bold; vertical-align: middle; color: ${Number(balQty) === 0 ? "#d32f2f" : "#2e7d32"};">
                ${balQty}
              </td>
              <td style="padding: 5px 6px; font-size: 10px; text-align: center; font-weight: bold; vertical-align: middle; color: ${Number(saleQty) === 0 ? "#d32f2f" : "#0284c7"};">
                ${saleQty}
              </td>
            </tr>
          `;
        })
        .join("");

      tempDiv.innerHTML = `
        <div style="margin-bottom: 12px; border-bottom: 2px solid #1a365d; padding-bottom: 8px; display: flex; justify-content: space-between; align-items: flex-end; page-break-inside: avoid; page-break-after: avoid;">
          <div>
            <h2 style="margin: 0; color: #1a365d; font-size: 18px; font-weight: bold;">Products Sale Report</h2>
            <p style="margin: 3px 0 0; color: #666; font-size: 11px;">
              Total Products: <strong>${sortedProducts.length}</strong> | Total Sales Qty: <strong>${totalSaleQty}</strong>
            </p>
          </div>
          <div style="text-align: right;">
            <p style="margin: 0; color: #666; font-size: 11px;">Period: <strong>${dateStr}</strong></p>
          </div>
        </div>

        <table style="width: 100%; border-collapse: collapse; margin-top: 5px; margin-bottom: 0px; font-family: Arial, sans-serif;">
          <thead style="display: table-header-group;">
            <tr style="background-color: #1a365d; color: #ffffff; page-break-inside: avoid;">
              <th style="padding: 6px 5px; font-size: 10px; text-align: center; width: 4%;">#</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: left; width: 14%;">Product Code</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: left; width: 18%;">Product Name</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: left; width: 12%;">Category</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: left; width: 12%;">Sub Category</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: right; width: 8%;">Price</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: center; width: 6%;">Size</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: center; width: 7%;">Color</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: center; width: 7%;">Image</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: center; width: 6%;">Stock</th>
              <th style="padding: 6px 5px; font-size: 10px; text-align: center; width: 6%;">Total Sale</th>
            </tr>
          </thead>
          <tbody>
            ${rowsHtml}
          </tbody>
        </table>
      `;

      const opt = {
        margin: [8, 8, 8, 8],
        filename: `Product_Sales_${new Date().toLocaleDateString("en-GB").replace(/\//g, "-")}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
        pagebreak: { mode: "css" },
      };

      await html2pdf().set(opt).from(tempDiv).save();
    } catch (err) {
      console.error("PDF download error:", err);
      alert("Failed to download PDF");
    } finally {
      setDownloadingPdf(false);
    }
  };

  // Download Single Product Excel with Customer Breakdown
  const downloadSingleProductExcel = async (record) => {
    try {
      const productId = record.product_id;
      let customerData = totalCustomersSale[productId];
      if (!customerData) {
        const res = await postMethod("api/masters/retailer/product_sale_report_by_customer", {
          product_id: productId,
          from_date: moment(dashboardShowDate.startDate).format("YYYY/MM/DD"),
          to_date: moment(dashboardShowDate.endDate).format("YYYY/MM/DD"),
        });
        customerData = res?.data || [];
        setTotalCustomersSale((prev) => ({
          ...prev,
          [productId]: customerData,
        }));
      }

      const dateStr = `${moment(dashboardShowDate.startDate).format("DD-MM-YYYY")}_to_${moment(dashboardShowDate.endDate).format("DD-MM-YYYY")}`;

      const sheetData = [
        ["PRODUCT SALE DETAILS"],
        ["Product Code", record.product_code || "-"],
        ["Product Name", record.product_name || "-"],
        ["Category", record.category_name || "-"],
        ["Sub Category", record.subcategory_name || "-"],
        ["Price", record.price != null ? Number(record.price).toFixed(2) : "-"],
        ["Size", record.size_length || "-"],
        ["Color", record.color || "-"],
        ["Balance Qty", record.balance_qty != null ? record.balance_qty : 0],
        ["Total Sales Qty", record.sales_qty != null ? record.sales_qty : 0],
        ["Date Range", `${moment(dashboardShowDate.startDate).format("DD/MM/YYYY")} - ${moment(dashboardShowDate.endDate).format("DD/MM/YYYY")}`],
        [],
        ["CUSTOMER SALES BREAKDOWN"],
        ["S.No", "Invoice No", "Customer Name", "Mobile", "Customer Type", "Quantity", "Date & Time"],
      ];

      if (customerData.length > 0) {
        customerData.forEach((c, idx) => {
          sheetData.push([
            idx + 1,
            c.invoice_no || "-",
            c.customer_name || "-",
            c.mobile || "-",
            c.type || "-",
            c.quantity ?? 0,
            formatDateTime(c.date_time),
          ]);
        });
      } else {
        sheetData.push(["No customer sale transactions found for this product in selected period."]);
      }

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      worksheet["!cols"] = [
        { wch: 16 },
        { wch: 22 },
        { wch: 24 },
        { wch: 16 },
        { wch: 16 },
        { wch: 12 },
        { wch: 20 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Product Sale");
      XLSX.writeFile(workbook, `Product_Sale_${record.product_code || "item"}_${dateStr}.xlsx`);
    } catch (err) {
      console.error("Single Excel error:", err);
      alert("Failed to export Excel for this product");
    }
  };

  // Download Single Product PDF with Customer Breakdown
  const downloadSingleProductPDF = async (record) => {
    try {
      const productId = record.product_id;
      let customerData = totalCustomersSale[productId];
      if (!customerData) {
        const res = await postMethod("api/masters/retailer/product_sale_report_by_customer", {
          product_id: productId,
          from_date: moment(dashboardShowDate.startDate).format("YYYY/MM/DD"),
          to_date: moment(dashboardShowDate.endDate).format("YYYY/MM/DD"),
        });
        customerData = res?.data || [];
        setTotalCustomersSale((prev) => ({
          ...prev,
          [productId]: customerData,
        }));
      }

      const imgSrc = record.image_path
        ? record.isImageUrl === true || record.isImageUrl === "true"
          ? record.image_path
          : (record.url_image || "") + record.image_path
        : null;
      const base64Img = await loadImageAsBase64(imgSrc);

      const dateStr = `${moment(dashboardShowDate.startDate).format("DD/MM/YYYY")} - ${moment(dashboardShowDate.endDate).format("DD/MM/YYYY")}`;
      const tempDiv = document.createElement("div");
      tempDiv.id = `single-product-pdf-${record.product_code}`;
      tempDiv.style.padding = "0px";
      tempDiv.style.margin = "0px";
      tempDiv.style.boxSizing = "border-box";
      tempDiv.style.fontFamily = "Arial, sans-serif";
      tempDiv.style.background = "#ffffff";
      tempDiv.style.color = "#333333";
      tempDiv.style.width = "100%";

      const customerRows = customerData.length > 0
        ? customerData
            .map(
              (c, idx) => `
            <tr style="page-break-inside: avoid; border-bottom: 1px solid #e2e8f0; ${idx % 2 === 1 ? "background-color: #f8fafc;" : ""}">
              <td style="padding: 6px 8px; text-align: center; font-size: 10px;">${idx + 1}</td>
              <td style="padding: 6px 8px; font-weight: bold; font-size: 10px;">${c.invoice_no || "-"}</td>
              <td style="padding: 6px 8px; font-size: 10px;">${c.customer_name || "-"}</td>
              <td style="padding: 6px 8px; font-size: 10px;">${c.mobile || "-"}</td>
              <td style="padding: 6px 8px; font-size: 10px;">${c.type || "-"}</td>
              <td style="padding: 6px 8px; text-align: center; font-weight: bold; color: #1d4ed8; font-size: 10px;">${c.quantity ?? 0}</td>
              <td style="padding: 6px 8px; font-size: 10px;">${formatDateTime(c.date_time)}</td>
            </tr>
          `
            )
            .join("")
        : `<tr><td colspan="7" style="text-align: center; padding: 15px; color: #64748b; font-size: 11px;">No customer sale transactions found for this product in selected period.</td></tr>`;

      tempDiv.innerHTML = `
        <div style="margin-bottom: 15px; border-bottom: 2px solid #1a365d; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: flex-end;">
          <div>
            <h2 style="margin: 0; color: #1a365d; font-size: 18px; font-weight: bold;">Product Sale & Customer Breakdown</h2>
            <p style="margin: 3px 0 0; color: #666; font-size: 11px;">Product Code: <strong>${record.product_code || "-"}</strong></p>
          </div>
          <div style="text-align: right;">
            <p style="margin: 0; color: #666; font-size: 11px;">Period: <strong>${dateStr}</strong></p>
          </div>
        </div>

        <div style="display: flex; gap: 15px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 12px 15px; margin-bottom: 15px; align-items: center;">
          ${base64Img ? `<img src="${base64Img}" width="65" height="65" style="width: 65px; height: 65px; object-fit: cover; border-radius: 6px; border: 1px solid #cbd5e1;" />` : ""}
          <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; width: 100%; font-size: 11px;">
            <div><span style="color: #64748b;">Name:</span> <strong style="color: #0f172a;">${record.product_name || "-"}</strong></div>
            <div><span style="color: #64748b;">Category:</span> <strong style="color: #0f172a;">${record.category_name || "-"}</strong></div>
            <div><span style="color: #64748b;">Sub Category:</span> <strong style="color: #0f172a;">${record.subcategory_name || "-"}</strong></div>
            <div><span style="color: #64748b;">Price:</span> <strong style="color: #0f172a;">₹${record.price != null ? Number(record.price).toFixed(2) : "-"}</strong></div>
            <div><span style="color: #64748b;">Size:</span> <strong style="color: #0f172a;">${record.size_length || "-"}</strong></div>
            <div><span style="color: #64748b;">Color:</span> <strong style="color: #0f172a;">${record.color || "-"}</strong></div>
            <div><span style="color: #64748b;">Stock Balance:</span> <strong style="color: ${Number(record.balance_qty || 0) === 0 ? "#d32f2f" : "#16a34a"};">${record.balance_qty != null ? record.balance_qty : 0}</strong></div>
            <div><span style="color: #64748b;">Total Sold Qty:</span> <strong style="color: #1d4ed8; font-size: 13px;">${record.sales_qty != null ? record.sales_qty : 0}</strong></div>
          </div>
        </div>

        <h3 style="font-size: 13px; font-weight: bold; color: #0f172a; margin: 15px 0 8px;">Customer Transactions (${customerData.length})</h3>
        <table style="width: 100%; border-collapse: collapse; font-family: Arial, sans-serif;">
          <thead style="display: table-header-group;">
            <tr style="background-color: #1a365d; color: #ffffff; page-break-inside: avoid;">
              <th style="padding: 6px 8px; font-size: 10px; text-align: center; width: 5%;">#</th>
              <th style="padding: 6px 8px; font-size: 10px; text-align: left; width: 18%;">Invoice No</th>
              <th style="padding: 6px 8px; font-size: 10px; text-align: left; width: 22%;">Customer Name</th>
              <th style="padding: 6px 8px; font-size: 10px; text-align: left; width: 15%;">Mobile</th>
              <th style="padding: 6px 8px; font-size: 10px; text-align: left; width: 12%;">Type</th>
              <th style="padding: 6px 8px; font-size: 10px; text-align: center; width: 10%;">Quantity</th>
              <th style="padding: 6px 8px; font-size: 10px; text-align: left; width: 18%;">Date & Time</th>
            </tr>
          </thead>
          <tbody>
            ${customerRows}
          </tbody>
        </table>
      `;

      const opt = {
        margin: [8, 8, 8, 8],
        filename: `Product_${record.product_code || "sale"}_${new Date().toLocaleDateString("en-GB").replace(/\//g, "-")}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
        pagebreak: { mode: "css" },
      };

      await html2pdf().set(opt).from(tempDiv).save();
    } catch (err) {
      console.error("Single PDF error:", err);
      alert("Failed to export PDF for this product");
    }
  };

  const renderImage = (record) => {
    if (!record.image_path) {
      return (
        <span className="text-muted">
          No Image
        </span>
      );
    }

    if (
      record.isImageUrl === true ||
      record.isImageUrl === "true"
    ) {
      return (
        <img
          src={record.image_path}
          width="40"
          height="40"
          alt="product"
          style={{
            objectFit: "cover",
            borderRadius: "4px",
          }}
        />
      );
    }

    return (
      <img
        src={(record.url_image || "") + record.image_path}
        width="40"
        height="40"
        alt="product"
        style={{
          objectFit: "cover",
          borderRadius: "4px",
        }}
      />
    );
  };

  const renderCustomerSaleTable = (record) => {
    const productId = record.product_id;

    if (!expandedRows[productId]) {
      return null;
    }

    const loadingCustomerSale = customerSaleLoading[productId];

    const customerData = totalCustomersSale[productId] || [];

    return (
      <tr>
        <td
          colSpan="11"
          style={{
            padding: "0",
          }}
        >
          <div
            style={{
              background: "#f8f9fa",
              borderTop: "1px solid #ddd",
              borderBottom: "1px solid #ddd",
              padding: "15px 20px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5
                  className="mb-1"
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Customer Sale Details
                </h5>

                <small className="text-muted">
                  Product Code:{" "}
                  <strong>
                    {record.product_code || "-"}
                  </strong>
                </small>
              </div>

              {!loadingCustomerSale && (
                <span className="badge badge-primary">
                  {customerData.length} Records
                </span>
              )}
            </div>

            {loadingCustomerSale ? (
              <div className="text-center py-4">
                <span
                  className="spinner-border spinner-border-sm text-primary mr-2"
                  role="status"
                ></span>

                Loading customer sale details...
              </div>
            ) : customerData.length === 0 ? (
              <div
                className="text-center py-4"
                style={{
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
              >
                <i className="fa fa-info-circle mr-2 text-muted"></i>

                <span className="text-muted">
                  No Data Found
                </span>
              </div>
            ) : (
              <div className="table-responsive">
                <table
                  className="table table-bordered table-hover mb-0"
                  style={{
                    background: "#fff",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          width: "60px",
                        }}
                      >
                        S.No
                      </th>

                      <th>Customer Name</th>

                      <th>Mobile</th>

                      <th>Type</th>

                      <th>Category Name</th>

                      <th>Quantity</th>

                      <th>Invoice No</th>

                      <th>Date Time</th>

                      <th>Bill View</th>
                    </tr>
                  </thead>

                  <tbody>
                    {customerData.map((customer, index) => (
                      <tr
                        key={
                          customer.invoice_no ||
                          customer.id ||
                          index
                        }
                      >
                        <td>{index + 1}</td>

                        <td>
                          {customer.customer_name || "-"}
                        </td>

                        <td>
                          {customer.mobile || "-"}
                        </td>

                        <td>
                          {customer.type || "-"}
                        </td>

                        <td>
                          {customer.category_name || "-"}
                        </td>

                        <td>
                          {customer.quantity ?? 0}
                        </td>

                        <td>
                          {customer.invoice_no || "-"}
                        </td>

                        <td>
                          {formatDateTime(
                            customer.date_time
                          )}
                        </td>

                        <td>
                          <button
                            className="btn btn-link btn-sm"
                            title="View Invoice PDF"
                            onClick={() =>
                              window.open(
                                customer.bill_pdf_url,
                                "_blank"
                              )
                            }
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </td>
      </tr>
    );
  };

  const renderProductTable = () => {
    if (tableState.loading) {
      return (
        <tbody>
          <tr>
            <td
              colSpan="11"
              className="text-center py-4"
            >
              Loading...
            </td>
          </tr>
        </tbody>
      );
    }

    if (
      !sortedProducts ||
      sortedProducts.length === 0
    ) {
      return (
        <tbody>
          <tr>
            <td
              colSpan="11"
              className="text-center py-4 text-muted"
            >
              No products found
            </td>
          </tr>
        </tbody>
      );
    }

    return (
      <tbody>
        {sortedProducts.map((record, index) => {
          const productId = record.product_id;

          return (
            <React.Fragment
              key={
                productId ||
                record.product_code ||
                index
              }
            >
              {/* PRODUCT MAIN ROW */}

              <tr>
                {/* PRODUCT CODE */}
                <td>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
                      <span
                        onClick={() =>
                          toggleCustomerSale(
                            productId
                          )
                        }
                        style={{
                          cursor: "pointer",
                          marginRight: "6px",
                          color: "#007bff",
                          fontWeight: "bold",
                          width: "16px",
                          flexShrink: 0,
                        }}
                      >
                        {expandedRows[productId]
                          ? "▼"
                          : "▶"}
                      </span>

                      <span
                        onClick={() =>
                          toggleCustomerSale(
                            productId
                          )
                        }
                        style={{
                          cursor: "pointer",
                          color: "#007bff",
                          fontWeight: "600",
                          wordBreak: "break-all",
                        }}
                      >
                        {record.product_code || "-"}
                      </span>
                    </div>

                    {/* 3-Dot Dropdown */}
                    <div className="dropdown ml-1" style={{ position: "relative", flexShrink: 0 }}>
                      <button
                        type="button"
                        className="btn btn-xs btn-icon btn-light"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveDropdownId(activeDropdownId === productId ? null : productId);
                        }}
                        style={{
                          width: "22px",
                          height: "22px",
                          borderRadius: "4px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid #cbd5e1",
                          backgroundColor: activeDropdownId === productId ? "#e2e8f0" : "#ffffff",
                          cursor: "pointer",
                          padding: 0,
                        }}
                        title="Export Product"
                      >
                        <i className="fa fa-ellipsis-v text-muted" style={{ fontSize: "11px" }}></i>
                      </button>

                      {activeDropdownId === productId && (
                        <div
                          className="dropdown-menu show shadow-lg"
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            position: "absolute",
                            left: 0,
                            top: "100%",
                            zIndex: 1050,
                            minWidth: "155px",
                            padding: "6px 0",
                            margin: "4px 0 0",
                            backgroundColor: "#ffffff",
                            border: "1px solid #e2e8f0",
                            borderRadius: "8px",
                            boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
                          }}
                        >
                          <button
                            type="button"
                            className="dropdown-item d-flex align-items-center py-2 px-3"
                            style={{ fontSize: "12px", cursor: "pointer", color: "#dc2626", fontWeight: "600" }}
                            onClick={() => {
                              setActiveDropdownId(null);
                              downloadSingleProductPDF(record);
                            }}
                          >
                            <i className="flaticon2-document mr-2 text-danger"></i>
                            Download PDF
                          </button>
                          <button
                            type="button"
                            className="dropdown-item d-flex align-items-center py-2 px-3"
                            style={{ fontSize: "12px", cursor: "pointer", color: "#16a34a", fontWeight: "600" }}
                            onClick={() => {
                              setActiveDropdownId(null);
                              downloadSingleProductExcel(record);
                            }}
                          >
                            <i className="flaticon2-download mr-2 text-success"></i>
                            Download Excel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </td>

                {/* PRODUCT NAME */}

                <td>
                  {record.product_name || "-"}
                </td>

                {/* CATEGORY */}

                <td>
                  {record.category_name || "-"}
                </td>

                {/* SUB CATEGORY */}

                <td>
                  {record.subcategory_name || "-"}
                </td>

                {/* PRICE */}

                <td>
                  {record.price != null
                    ? Number(record.price).toFixed(2)
                    : "-"}
                </td>

                {/* SIZE */}

                <td>
                  {record.size_length || "-"}
                </td>

                {/* COLOR */}

                <td>
                  {record.color || "-"}
                </td>

                {/* IMAGE */}

                <td>
                  {renderImage(record)}
                </td>

                {/* BALANCE QTY */}

                <td>
                  {Number(record.balance_qty || 0) === 0 ? (
                    <span className="text-danger font-weight-bold">
                      0
                    </span>
                  ) : (
                    <span className="text-success font-weight-bold">
                      {record.balance_qty}
                    </span>
                  )}
                </td>

                {/* TOTAL SALE */}
                <td style={{ backgroundColor: "#f0f9ff", textAlign: "center" }}>
                  {Number(record.sales_qty || 0) === 0 ? (
                    <span
                      className="badge badge-light-danger font-weight-bold"
                      style={{ fontSize: "12px", padding: "4px 8px" }}
                    >
                      0
                    </span>
                  ) : (
                    <span
                      className="badge font-weight-bolder"
                      style={{
                        fontSize: "13px",
                        padding: "4px 10px",
                        backgroundColor: "#dbeafe",
                        color: "#1d4ed8",
                      }}
                    >
                      {record.sales_qty}
                    </span>
                  )}
                </td>

                {/* ACTION */}
                <td>
                  <ProductDetails
                    data={record.product_code}
                  />
                </td>
              </tr>

              {/* CUSTOMER SALE */}

              {renderCustomerSaleTable(record)}
            </React.Fragment>
          );
        })}
      </tbody>
    );
  };
  const handleDateRangeContinue = () => {
    setTotalCustomersSale({});
    setExpandedRows({});

    toggleDashboardDataRange();

    fetchData();
  };
  return (
    <>
      {loading && <Loader />}


      <div className="card card-custom gutter-b">



        {/* Header Title Section */}
        <div
          className="card-header py-4"
          style={{
            background: "#ffffff",
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
            <div>
              <div className="d-flex align-items-center">
                <h3
                  className="font-weight-bolder mb-0 mr-3"
                  style={{
                    color: "#0f172a",
                    fontSize: "20px",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Products Sale Details
                </h3>
                <span
                  style={{
                    backgroundColor: "#e0f2fe",
                    color: "#0369a1",
                    fontSize: "12px",
                    fontWeight: "700",
                    padding: "4px 10px",
                    borderRadius: "20px",
                  }}
                >
                  {sortedProducts.length} Products
                </span>
              </div>
              <p
                className="text-muted mb-0 mt-1"
                style={{ fontSize: "13px" }}
              >
                Track real-time sales volume, stock turnover, and product analytics
              </p>
            </div>

            <div className="d-flex align-items-center flex-wrap gap-2 mt-3 mt-md-0">
              <button
                type="button"
                onClick={downloadPDF}
                disabled={downloadingPdf}
                className="btn btn-sm btn-outline-danger mr-2 font-weight-bold d-flex align-items-center"
                style={{
                  height: "38px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  pointerEvents: downloadingPdf ? "none" : "auto",
                }}
              >
                <i className="flaticon2-document mr-1"></i>
                {downloadingPdf ? "Generating PDF..." : "Download PDF"}
              </button>

              <button
                type="button"
                onClick={downloadExcel}
                disabled={downloadingExcel}
                className="btn btn-sm btn-outline-success mr-3 font-weight-bold d-flex align-items-center"
                style={{
                  height: "38px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  pointerEvents: downloadingExcel ? "none" : "auto",
                }}
              >
                <i className="flaticon2-download mr-1"></i>
                {downloadingExcel ? "Generating Excel..." : "Download Excel"}
              </button>

              <div
                onClick={toggleDashboardDataRange}
                style={{
                  cursor: "pointer",
                  backgroundColor: "#ffffff",
                  border: "1px solid #cbd5e1",
                  borderRadius: "10px",
                  padding: "8px 16px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  transition: "all 0.2s ease",
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    backgroundColor: "#eff6ff",
                    color: "#2563eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                  }}
                >
                  <i className="far fa-calendar-alt"></i>
                </div>
                <div>
                  <div style={{ fontSize: "10px", color: "#64748b", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Date Period
                  </div>
                  <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a" }}>
                    {moment(dashboardShowDate.startDate).format("DD MMM YYYY")} — {moment(dashboardShowDate.endDate).format("DD MMM YYYY")}
                  </div>
                </div>
                <i className="fa fa-chevron-down text-muted" style={{ fontSize: "11px", marginLeft: "4px" }}></i>
              </div>
            </div>
          </div>
        </div>

        {/* Dashboard Analytics & Filters Body */}
        <div
          className="card-body p-4"
          style={{
            background: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          {/* KPI Analytics Cards */}
          <div className="row mb-4">
            <div className="col-lg-4 col-md-6 mb-3 mb-lg-0">
              <div
                style={{
                  background: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "16px 20px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Total Products
                  </span>
                  <h4 style={{ fontSize: "24px", fontWeight: "800", color: "#0f172a", margin: "4px 0 0" }}>
                    {sortedProducts.length}
                  </h4>
                  <small style={{ color: "#94a3b8", fontSize: "11px" }}>Based on active filters</small>
                </div>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    backgroundColor: "#f0fdf4",
                    color: "#16a34a",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  <i className="fa fa-boxes"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-3 mb-lg-0">
              <div
                style={{
                  background: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "16px 20px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Total Units Sold
                  </span>
                  <h4 style={{ fontSize: "24px", fontWeight: "800", color: "#0284c7", margin: "4px 0 0" }}>
                    {sortedProducts.reduce(
                      (total, record) => total + Number(record.sales_qty || 0),
                      0
                    )}
                  </h4>
                  <small style={{ color: "#94a3b8", fontSize: "11px" }}>In selected date period</small>
                </div>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    backgroundColor: "#f0f9ff",
                    color: "#0284c7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  <i className="fa fa-chart-line"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <div
                style={{
                  background: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "16px 20px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Category Filter
                  </span>
                  <h4
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#6366f1",
                      margin: "6px 0 0",
                      maxWidth: "200px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={selectedCategory || "All Categories"}
                  >
                    {selectedCategory || "All Categories"}
                  </h4>
                  <small style={{ color: "#94a3b8", fontSize: "11px" }}>
                    {selectedSubCategory ? `Sub: ${selectedSubCategory}` : `${categories.length} total categories`}
                  </small>
                </div>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    backgroundColor: "#eef2ff",
                    color: "#6366f1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  <i className="fa fa-layer-group"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Unified Modern Filter Bar */}
          <div
            style={{
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              padding: "18px 20px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
            }}
          >
            <div className="row align-items-end">
              {/* Category */}
              <div className="col-lg-3 col-md-3 col-sm-6 mb-3 mb-lg-0">
                <label
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  Category
                </label>
                <select
                  className="form-control"
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  style={{
                    height: "42px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    backgroundColor: "#f8fafc",
                    fontSize: "13px",
                    fontWeight: selectedCategory ? "600" : "500",
                    color: selectedCategory ? "#0f172a" : "#64748b",
                    cursor: "pointer",
                  }}
                >
                  <option value="">All Categories</option>
                  {categories.map((category, index) => {
                    const categoryName =
                      category.category_name || category.name || "";
                    return (
                      <option
                        key={category.category_id || category.id || index}
                        value={categoryName}
                      >
                        {categoryName}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* Sub Category */}
              <div className="col-lg-3 col-md-3 col-sm-6 mb-3 mb-lg-0">
                <label
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  Sub Category
                </label>
                <select
                  className="form-control"
                  value={selectedSubCategory}
                  onChange={handleSubCategoryChange}
                  disabled={!selectedCategory}
                  style={{
                    height: "42px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    backgroundColor: selectedCategory ? "#f8fafc" : "#f1f5f9",
                    fontSize: "13px",
                    fontWeight: selectedSubCategory ? "600" : "500",
                    color: selectedSubCategory ? "#0f172a" : "#94a3b8",
                    cursor: selectedCategory ? "pointer" : "not-allowed",
                  }}
                >
                  <option value="">All Sub Categories</option>
                  {subCategories.map((subCategory, index) => {
                    const subCategoryName =
                      subCategory.subcategory_name || subCategory.name || "";
                    return (
                      <option
                        key={subCategory.subcategory_id || subCategory.id || index}
                        value={subCategoryName}
                      >
                        {subCategoryName}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* Search */}
              <div className="col-lg-6 col-md-6 mb-3 mb-lg-0">
                <label
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  Search Product
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by code, product name, color, size..."
                    value={globalSearch}
                    onChange={handleGlobalSearch}
                    style={{
                      height: "42px",
                      paddingLeft: "38px",
                      paddingRight: globalSearch ? "36px" : "14px",
                      borderRadius: "8px",
                      border: "1px solid #cbd5e1",
                      backgroundColor: "#f8fafc",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#1e293b",
                    }}
                  />
                  <i
                    className="fa fa-search"
                    style={{
                      position: "absolute",
                      left: "14px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#94a3b8",
                      fontSize: "13px",
                    }}
                  ></i>
                  {globalSearch && (
                    <button
                      type="button"
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        color: "#94a3b8",
                        cursor: "pointer",
                        padding: "4px",
                        fontSize: "14px",
                      }}
                      onClick={() => setGlobalSearch("")}
                      title="Clear search"
                    >
                      <i className="fa fa-times-circle"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table table-bordered table-hover"
              style={{
                width: "100%",
                minWidth: "1150px",
                tableLayout: "fixed",
              }}
            >
              <thead>
                <tr>
                  {/* PRODUCT CODE */}
                  <th
                    onClick={handleProductCodeSort}
                    style={{
                      cursor: "pointer",
                      userSelect: "none",
                      width: "14%",
                    }}
                    title="Sort by Total Sale"
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Product Code</span>
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "12px",
                        }}
                      >
                        {saleSortOrder === "desc"
                          ? "▼"
                          : saleSortOrder === "asc"
                            ? "▲"
                            : "↕"}
                      </span>
                    </div>
                  </th>

                  <th style={{ width: "17%" }}>Product Name</th>

                  <th style={{ width: "11%" }}>Category</th>

                  <th style={{ width: "11%" }}>Sub Category</th>

                  <th style={{ width: "8%" }}>Price</th>

                  <th style={{ width: "6%" }}>Size</th>

                  <th style={{ width: "7%" }}>Color</th>

                  <th style={{ width: "7%" }}>Image</th>

                  <th style={{ width: "7%" }}>Balance Qty</th>

                  <th style={{ width: "7%", backgroundColor: "#eff6ff", color: "#1d4ed8" }}>Total Sale</th>

                  <th style={{ width: "5%" }}>Action</th>
                </tr>
              </thead>

              {renderProductTable()}

              {sortedProducts && sortedProducts.length > 0 && !tableState.loading && (
                <tfoot>
                  <tr style={{ background: "#f8fafc", borderTop: "2px solid #cbd5e1" }}>
                    <td colSpan="8" style={{ textAlign: "right", padding: "12px 14px", fontWeight: "700", color: "#0f172a", fontSize: "13px" }}>
                      TOTAL:
                    </td>
                    <td style={{ textAlign: "center", padding: "12px 8px", fontWeight: "700", color: "#1e293b", fontSize: "13px" }}>
                      {sortedProducts.reduce((sum, r) => sum + Number(r.balance_qty || 0), 0)}
                    </td>
                    <td style={{ textAlign: "center", padding: "12px 8px", backgroundColor: "#dbeafe", fontWeight: "800", fontSize: "14px", color: "#1d4ed8" }}>
                      {sortedProducts.reduce((sum, r) => sum + Number(r.sales_qty || 0), 0)}
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalDashboardDataRange}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered
      >
        <ModalHeader>
          Data Range

          <i
            className="fa fa-close pull-right pointerShow"
            onClick={toggleDashboardDataRange}
            style={{
              cursor: "pointer",
            }}
          ></i>
        </ModalHeader>

        <ModalBody
          style={{
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          <div className="row">
            <div className="col-sm-12">
              <DateRangePicker
                onChange={(item) => {
                  const selection = item.selection;

                  setDateRangeState([
                    selection,
                  ]);

                  setDashboardShowDate({
                    startDate:
                      selection.startDate,
                    endDate:
                      selection.endDate,
                    key: "selection",
                  });
                }}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={dateRangeState}
                direction="horizontal"
              />
            </div>

            <div className="col-sm-12 text-right mt-3">
              <span
                className="badge-success pointerShow"
                onClick={handleDateRangeContinue}
                style={{
                  cursor: "pointer",
                  padding: "8px 15px",
                  borderRadius: "4px",
                  display: "inline-block",
                }}
              >
                Continue
              </span>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ProductSale;